// extracted by mini-css-extract-plugin
export default {"description":"filingStatus_description__6jNTj","content":"filingStatus_content__1cXrV"};